import React, {Component} from "react";

import {
    ListGroup,
    ListGroupItem,
    Jumbotron,
    ListGroupItemText,
    Alert
} from 'reactstrap';


import Nav from '../../components/nav/Nav';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import {
    getChecklistsResponse,
    getChecklists
} from '../../actions/checklist';

import {
    getChecklists as getChecklistsService
} from '../../services/checklist';

import Spinner from '../../components/spinner/Spinner';
import env from "../../env";
import {getStoredData} from "../../Helpers";

class List  extends Component{

    constructor(props) {

        super(props);

        this.state = {
            list: [],
            loading: true,
            site: null,
            error: null,
            savedChecklists: null,
        };
    }

    componentWillReceiveProps(nextProps){

        const {loading, error, list} = nextProps.checklists;

        this.setState({loading,error,list});
    }


    componentDidMount(){

        let savedChecklists = getStoredData('checklists');
        if (savedChecklists){
            savedChecklists = JSON.parse(savedChecklists);
        }

        const {loggedIn, site} = this.props.account;

        if(!loggedIn){
            this.props.history.push(`${env.url}/login`);
        }

        if(site === null || !site)
            this.props.history.push(`${env.url}/`);

        let props = this.props;
        let id = site.id;

        props.getChecklists();

        getChecklistsService({id}).then(function(resp){
            props.getChecklistsResponse(resp);
        }).catch(function(e){
            console.log(e);
        });

        this.setState({
            site,
            savedChecklists,
        });

    }

    completeChecklist = (e, id) => {
        e.preventDefault();
        this.props.history.push(`${env.url}/checklists/form/${id}`);
    };

    hasSavedChecklist = (id) => {
        const {
            savedChecklists,
        } = this.state;

        return (savedChecklists && savedChecklists[`checklist_${id}`]);
    };

    render(){

        const {
            list,
            loading,
            site,
            error,
        } = this.state;

        return(
            <div className="checklists">
                <Nav
                    history={this.props.history}
                    location={this.props.location}/>
                {
                    error?
                        <Alert color="danger">{error}</Alert>:null
                }


                {
                    loading?
                        <Spinner/>
                        :
                        (
                            <div>
                                <Jumbotron>
                                    <p className="lead">
                                        {site? site.name : ''} Checklists
                                    </p>
                                    <hr className="my-2" />
                                    <p>Click on a checklist to complete it!</p>
                                </Jumbotron>

                                <div className="inner">

                                    <div className="list">
                                        {
                                            list.length > 0?
                                                (
                                                    <ListGroup>
                                                        {
                                                            list.map(checklist => (
                                                                <ListGroupItem
                                                                    style={this.hasSavedChecklist(checklist.checklist_template_id)? {backgroundColor: '#17a2b8'}: {}}
                                                                    tag="a"
                                                                    action
                                                                    key={checklist.checklist_template_id}
                                                                    onClick={(e) => this.completeChecklist(e, checklist.checklist_template_id) }>

                                                                    <ListGroupItemText>
                                                                        {
                                                                            this.hasSavedChecklist(checklist.checklist_template_id)?
                                                                                <span
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        top: '0',
                                                                                        color: '#fff',
                                                                                        fontSize: '10px',
                                                                                        right: '2px',
                                                                                    }}>Saved. Click to continue.</span>: null
                                                                        }
                                                                    <span>
                                                                        Checklist Name:
                                                                    </span>
                                                                    <span>
                                                                        {checklist.checklist_name}
                                                                    </span>
                                                                    </ListGroupItemText>

                                                                    {/*<ListGroupItemText>*/}
                                                                    {/*    <span>*/}
                                                                    {/*        Management Measure:*/}
                                                                    {/*    </span>*/}
                                                                    {/*    <span>*/}
                                                                    {/*        {checklist.aspect_name? checklist.measure: 'N/A'}*/}
                                                                    {/*    </span>*/}
                                                                    {/*</ListGroupItemText>*/}

                                                                </ListGroupItem>
                                                            ))
                                                        }
                                                    </ListGroup>
                                                )

                                                :
                                                (
                                                    <p className='nothing'>No Checklist available</p>
                                                )

                                        }

                                    </div>
                                </div>
                            </div>
                        )
                }

            </div>
        )
    }
}


const mapStateToProps = ({ account, checklists}) => ({
    account,
    checklists
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getChecklistsResponse: (resp) => getChecklistsResponse(resp),
    getChecklists: () => getChecklists()
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(List)




// WEBPACK FOOTER //
// ./src/screens/checklists/List.js